import React from "react";
import {
  ButtonCode,
  TitleVerificationCode,
  QrImg,
  ContentManualTwoFactor,
} from "./LoginPageVerify.styled";
import { Col, Form } from "react-bootstrap";
import { theme as themeConfig } from "../../themes/themes";
import PropTypes from "prop-types";

const LoginPageVerify = ({
  handleInput,
  handleChange,
  SignInVerify,
  codeQR,
  existsQR,
  code,
  setShowManualTwoFactor,
}) => {
  return (
    <>
      <TitleVerificationCode>Two-Factor authentication</TitleVerificationCode>

      {existsQR ? null : <></>}
      <QrImg
        className={"my-2"}
        src={"data:image/png;base64," + codeQR}
        alt=""
      />
      <div
        className={"my-2"}
        style={{ height: "3em", marginLeft: "5%", width: "90%" }}
      >
        <Form>
          <Form.Group as={Col} md="12">
            <Form.Control
              type="text"
              name="code"
              id="inputCode"
              placeholder="Verification Code"
              required="required"
              autoComplete={"off"}
              value={code}
              maxLength={6}
              onChange={handleChange}
              onKeyDown={handleInput}
              style={{ backgroundColor: themeConfig.neutral.gray[200] }}
            ></Form.Control>
          </Form.Group>
        </Form>
      </div>

      {existsQR ? null : (
        <ContentManualTwoFactor>
          <p>
            <span onClick={() => setShowManualTwoFactor(true)}>Click here</span>{" "}
            for a step by step guide on how to install your authenticator app.
          </p>
        </ContentManualTwoFactor>
      )}

      <ButtonCode
        className={"my-2"}
        onClick={() => {
          SignInVerify();
        }}
      >
        Continue
      </ButtonCode>
    </>
  );
};

export default LoginPageVerify;

LoginPageVerify.propTypes = {
  handleInput: PropTypes.func,
  handleChange: PropTypes.func,
  SignInVerify: PropTypes.func,
  codeQR: PropTypes.string,
  existsQR: PropTypes.bool,
  code: PropTypes.string,
  setShowManualTwoFactor: PropTypes.func,
};
